var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStartProcess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_start_process",
    d: "M30.828,23.994a.931.931,0,1,1-.931.931A.931.931,0,0,1,30.828,23.994ZM24.31,30.512a.931.931,0,1,0,.931-.931A.931.931,0,0,0,24.31,30.512Zm2.056-3.53a.931.931,0,1,0,.931-.931A.931.931,0,0,0,26.366,26.981Zm13.734.282a9.22,9.22,0,0,0-4.794-3.235.931.931,0,1,0-.5,1.794A7.346,7.346,0,0,1,38.626,28.4a7.214,7.214,0,0,1,1.512,4.443,7.3,7.3,0,0,1-11.726,5.792c-.53-.406-1.649-1.681-1.111-2.56l-1.968-.319a4.48,4.48,0,0,0,.055,1.987,4.625,4.625,0,0,0,1.095,1.683A9.154,9.154,0,0,0,40.1,27.264ZM25.862,40.753V36.327l4.453.99a.931.931,0,0,0,.4-1.818l-5.586-1.241A.931.931,0,0,0,24,35.167v5.586a.931.931,0,1,0,1.862,0Z",
    transform: "translate(-24 -23.994)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStartProcess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_start_process.8cd385d1ea81603d99460016c1f46199.svg";